// import React from "react";
// import { createRoot, hydrateRoot } from "react-dom/client";
// import "./index.css";
// import App from "./App";
// import reportWebVitals from "./reportWebVitals";
// import { BrowserRouter } from "react-router-dom";


// const app = (
//     <BrowserRouter>
//       <App />
//     </BrowserRouter>
// );

// const rootEl = document.getElementById("root");
// const mode = rootEl?.dataset?.mode;

// if (rootEl && mode !== "php") {
//   if (rootEl.hasChildNodes()) {
//     hydrateRoot(rootEl, app);
//   } else {
//     createRoot(rootEl).render(app);
//   }
// }

// reportWebVitals();


import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { passwordResetPath } from './utils/passwordReset';

// A recovery release must change the bootloader URL, not just purge the CDN:
// browsers may still have cached an HTML fallback under the previous JS URL.
window.__KEPITHOR_BOOT_RELEASE__ = '2026-10-21-asset-recovery';

const mode = window.__PAGE_MODE__ || "spa";

if (passwordResetPath(window.location.pathname)) {
  const rootEl = document.getElementById('root');
  if (rootEl) import('./passwordResetEntry').then(m => m.mountPasswordReset(rootEl));
} else if (mode === "php") {
  import("./php_islands").then((m) => m.mountPhpIslands());
} else {
  const rootEl = document.getElementById("root");
  if (rootEl) import("./spa").then((m) => m.mountSpa(rootEl));
}

reportWebVitals();
